import { Route, Routes } from "react-router-dom";
import AddTabletV3 from "../../pages/V3/TabletsV3/AddTabletV3/AddTabletV3";
import EditTabletV3 from "../../pages/V3/TabletsV3/EditTabletV3/EditTabletV3";
import TabletsV3 from "../../pages/V3/TabletsV3/TabletsV3";
import { RequireAuth } from "../../utils/auth/auth";

export default function TabletsV3Router() {
  return (
    <Routes>
      <Route
        path=""
        element={
          <RequireAuth>
            <TabletsV3 />
          </RequireAuth>
        }
      />
      <Route
        path="add"
        element={
          <RequireAuth>
            <AddTabletV3 />
          </RequireAuth>
        }
      />
      <Route
        path="edit/:deviceId"
        element={
          <RequireAuth>
            <EditTabletV3 />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
